import { createReducer, on } from '@ngrx/store';
import * as fromTermsConditions from '../actions/terms.conditions.action';
import { StateSlice } from '@core/helpers/state-slice';

export type TermsConditionsState = StateSlice<boolean>;

export const initialState: TermsConditionsState = {
  data: false,
  loaded: false,
  loading: false,
  error: null,
};

const termsConditionsReducer = createReducer(
  initialState,
  on(fromTermsConditions.agreeTermsConditions, (state) => {
    return {
      ...state,
      data: true,
      loading: false,
      loaded: true,
    };
  }),
  on(fromTermsConditions.resetTermsConditions, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: TermsConditionsState | undefined,
  action: fromTermsConditions.TermsConditionsActions
) {
  return termsConditionsReducer(state, action);
}
